import _jsx from '@babel/runtime/helpers/jsx';
import React, { useRef, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _extends from '@babel/runtime/helpers/extends';
import classNames from 'classnames';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { trackCustomization } from '@andes/common/build/metrics';
export { canUseDOM } from 'exenv';
const Image = _ref => {
  let {
    className,
    width,
    height,
    src,
    src2x,
    title
  } = _ref;
  return /*#__PURE__*/(
    _jsx("img", {
      className: className,
      width: width,
      height: height,
      src: src,
      alt: title,
      srcSet: src2x && "".concat(src, " 1x, ").concat(src2x, " 2x")
    })
  );
};
var Image$1 = Image;
class CloseListener extends React.Component {
  constructor(props) {
    super(props);
    this.handleRef = this.handleRef.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.pressEscToClose = this.pressEscToClose.bind(this);
  }
  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.pressEscToClose, false);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.pressEscToClose, false);
  }
  pressEscToClose(event) {
    const {
      handleEsc = true,
      onCloseOutside
    } = this.props;
    if (handleEsc) {
      if (event.code === 'Escape') {
        onCloseOutside(event);
      }
    }
  }
  handleDocumentClick(event) {
    const {
      handleClick = true,
      onCloseOutside
    } = this.props;
    if (handleClick) {
      if (this.element && !this.element.contains(event.target)) {
        onCloseOutside(event);
      }
    }
  }
  handleRef(el) {
    const {
      children
    } = this.props;
    this.element = el;
    if (children.ref && typeof children.ref === 'function') {
      children.ref(el);
    }
  }
  render() {
    const {
      children
    } = this.props;
    return /*#__PURE__*/React.cloneElement(children, {
      ref: this.handleRef
    });
  }
}
var CloseListener$1 = CloseListener;
const Portal = _ref => {
  let {
    children,
    container,
    onMounted,
    className = ''
  } = _ref;
  const defaultNode = useRef();
  const containerPortal = useRef();
  const [mount, setMount] = useState(false);
  useEffect(() => {
    if (mount && typeof onMounted === 'function') {
      onMounted(true);
    }
  }, [mount]);
  useEffect(() => {
    var _defaultNode$current, _containerPortal$curr;
    defaultNode.current = document.createElement('div');
    (_defaultNode$current = defaultNode.current) === null || _defaultNode$current === void 0 || _defaultNode$current.setAttribute('class', className);
    containerPortal.current = container || document.body;
    (_containerPortal$curr = containerPortal.current) === null || _containerPortal$curr === void 0 || _containerPortal$curr.appendChild(defaultNode.current);
    setMount(true);
    return () => {
      if (defaultNode.current) {
        setTimeout(() => {
          var _containerPortal$curr2;
          (_containerPortal$curr2 = containerPortal.current) === null || _containerPortal$curr2 === void 0 || _containerPortal$curr2.removeChild(defaultNode.current);
        }, 0);
      }
    };
  }, []);
  return mount && defaultNode.current ? /*#__PURE__*/createPortal(children, defaultNode.current) : '';
};
var Portal$1 = Portal;
const Widther = WrappedComponent => {
  class WidtherHOC extends React.PureComponent {
    render() {
      let {
        className
      } = this.props;
      const {
        width
      } = this.props;
      if (width) {
        className = classNames(className, "andes-width--".concat(width));
      }
      return width !== null ? /*#__PURE__*/_jsx("div", {
        className: "andes-widther"
      }, "widther", /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
        className: className
      }))) : /*#__PURE__*/React.createElement(WrappedComponent, _extends({
        key: "widther"
      }, this.props));
    }
  }
  WidtherHOC.defaultProps = _objectSpread({}, WrappedComponent.defaultProps);
  WidtherHOC.displayName = WrappedComponent.displayName || 'WidtherHOC';
  return WidtherHOC;
};
var Widther$1 = Widther;
const _excluded$1 = ["children", "component"];
const nameSpace$1 = 'andes-visually-hidden';
const VisuallyHidden = _ref => {
  let {
      children,
      component: Component = 'span'
    } = _ref,
    other = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: nameSpace$1
  }, other), children);
};
var VisuallyHidden$1 = VisuallyHidden;
const _excluded = ["children", "component", "className"];
const nameSpace = 'andes-visually-hidden-focusable';
const VisuallyHiddenFocusable = _ref => {
  let {
      children,
      component: Component = 'button',
      className
    } = _ref,
    other = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: classNames(nameSpace, className)
  }, other), children);
};
var VisuallyHiddenFocusable$1 = VisuallyHiddenFocusable;
const withTracker = function (WrappedComponent) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  class TrackerHOC extends React.PureComponent {
    constructor(props) {
      super(props);
      if (typeof window === 'undefined' && props.extend) {
        trackCustomization({
          type: 'headless',
          component: options.name || WrappedComponent.displayName
        });
      }
    }
    render() {
      const {
        forwardedRef
      } = this.props;
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
        ref: forwardedRef
      }));
    }
  }
  return /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(TrackerHOC, _extends({}, props, {
    forwardedRef: ref
  })));
};
var withTracker$1 = withTracker;
export { CloseListener$1 as CloseListener, Image$1 as Image, Portal$1 as Portal, VisuallyHidden$1 as VisuallyHidden, VisuallyHiddenFocusable$1 as VisuallyHiddenFocusable, Widther$1 as Widther, withTracker$1 as withTracker };
